export interface BaseSchoolInterface {
  name: string
  /**
   * 主键 ID
   */
  id: number
}

export class BaseSchool implements BaseSchoolInterface {
  name: string
  /**
   * 主键 ID
   */
  id: number

  constructor(props: BaseSchoolInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      name: _name,
      id: _id,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.name = _name
    this.id = _id
  }
}
